<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-layer-group"></i>
        로그인
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">로그</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">로그인</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col>
        <!-- 탭으로 관리 -->
        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger">
          <b-tab title="사용자">
            <List-User ref="user_list" />
          </b-tab>
          <b-tab title="파트너">
            <List-partner ref="admin_list" />
          </b-tab>
          <b-tab title="관리자">
            <List-Admin ref="partner_list" />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>